import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}

// Initialize Meta Pixel
!function (f, b, e, v, n, t, s)
// @ts-ignore
{
  if (f.fbq) return;
  n = f.fbq = function () {
    n.callMethod ?
    // @ts-ignore
    n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  // @ts-ignore
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = !0;
  n.version = '2.0';
  // @ts-ignore
  n.queue = [];
  t = b.createElement(e);
  t.async = !0;
  // @ts-ignore
  t.src = v;
  s = b.getElementsByTagName(e)[0];
  // @ts-ignore
  s.parentNode.insertBefore(t, s);
}(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
window.fbq('init', '1553300692930973');
window.fbq('track', 'PageView');
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-240" data-mp="2u0g0stk6lygo" />);
}